/**
 * React application entry point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import App from './App';

// Google OAuth Client ID from environment variable.
// Client lives in GCP project ph-engineering-457116 (project number 663990533969).
// The previous client (992768271272-ohp96bp...) was permanently deleted on
// 2026-06-02 when the ph-rav-dash GCP project was deleted, breaking sign-in with
// Error 401: deleted_client. Web-application client; the QVT demo uses the Google
// Identity Services credential flow (<GoogleLogin>), so the demo's deployed URLs
// must be listed as Authorized JavaScript origins on this client.
const GOOGLE_CLIENT_ID: string =
  (import.meta.env.VITE_GOOGLE_CLIENT_ID as string | undefined) ??
  '663990533969-9577ksgn9h2lnpaom5cem7tim7p8q7on.apps.googleusercontent.com';

// Import Tailwind and shadcn styles
import './styles/globals.css';

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
